"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dbGuideReducer = void 0;
var DbGuideState_init_1 = require("@/pages/dbguide/states/DbGuideState.init");
var DbGuideAction_1 = require("@/pages/dbguide/actions/DbGuideAction");
var typesafe_actions_1 = require("typesafe-actions");
var myokay_map_1 = require("@okay/myokay-map");
exports.dbGuideReducer = function (state, action) {
    if (state === void 0) { state = DbGuideState_init_1.defaultDbGuideState; }
    switch (action.type) {
        case typesafe_actions_1.getType(DbGuideAction_1.default.onViewMapClicked): {
            return __assign(__assign({}, state), { showWelcome: !state.showWelcome });
        }
        case typesafe_actions_1.getType(DbGuideAction_1.default.onPanelToggleClicked): {
            return __assign(__assign({}, state), { hidePanel: !state.hidePanel });
        }
        case typesafe_actions_1.getType(DbGuideAction_1.default.setMenuItemOpen): {
            var newItems = state.menu.items.map(function (it) {
                if (it.key === action.payload.key) {
                    return __assign(__assign({}, it), { isOpened: action.payload.status });
                }
                return it;
            });
            return __assign(__assign({}, state), { menu: __assign(__assign({}, state.menu), { items: newItems }) });
        }
        case typesafe_actions_1.getType(DbGuideAction_1.default.setMapObjects): {
            return __assign(__assign({}, state), { mapState: __assign(__assign({}, state.mapState), { objects: action.payload }) });
        }
        case typesafe_actions_1.getType(DbGuideAction_1.default.setMapOpt): {
            return __assign(__assign({}, state), { mapState: __assign(__assign({}, state.mapState), { opts: action.payload }) });
        }
        // case getType(DbGuideAction.resetMap): {
        //   return {
        //     ...state,
        //     mapState: {
        //       ...state.mapState,
        //       opts: null,
        //       objects: [state.dbBoundary],
        //     },
        //   };
        // }
        case typesafe_actions_1.getType(DbGuideAction_1.default.setAccordianActive): {
            return __assign(__assign({}, state), { accordianActive: action.payload });
        }
        case typesafe_actions_1.getType(DbGuideAction_1.default.setAccordianHidden): {
            return __assign(__assign({}, state), { accordianHidden: action.payload });
        }
        case typesafe_actions_1.getType(DbGuideAction_1.default.setDetailActive): {
            return __assign(__assign({}, state), { detailActive: action.payload });
        }
        case typesafe_actions_1.getType(DbGuideAction_1.default.setDetailHidden): {
            return __assign(__assign({}, state), { detailHidden: action.payload });
        }
        case typesafe_actions_1.getType(DbGuideAction_1.default.setCurrentPlace): {
            return __assign(__assign({}, state), { currentPlace: action.payload });
        }
        case typesafe_actions_1.getType(DbGuideAction_1.default.addMapObject): {
            return __assign(__assign({}, state), { mapState: __assign(__assign({}, state.mapState), { objects: __spreadArrays(state.mapState.objects, [
                        action.payload,
                    ]) }) });
        }
        case typesafe_actions_1.getType(DbGuideAction_1.default.removeInfoWindow): {
            var infoWindowIndex = state.mapState.objects
                .findIndex(function (it) { return it.key === action.payload && it.kind === myokay_map_1.ObjectTypes.INFO_WINDOW; });
            var newObjects = __spreadArrays(state.mapState.objects.slice(0, infoWindowIndex), state.mapState.objects.slice(infoWindowIndex + 1));
            return __assign(__assign({}, state), { mapState: __assign(__assign({}, state.mapState), { objects: newObjects }) });
        }
    }
    return state;
};
